// extracted by mini-css-extract-plugin
module.exports = {"name":"KqLipbIRxZx3nXKYKGAQE","fieldsWrapper":"_3XuC18v17MUzgSPpKQ6nH2","row":"_1B6s-hrUX_F4bP7fIPKV_N"};